import { DeviceQueries } from 'Common/src/components/styled';
import styled from 'styled-components';

export const Overlay = styled.div`
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 200;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, .8);
`;

export const ModalContainer = styled.div<{ $wide?: boolean, $maxWidth?: string }>`
  background: var(--shine-bg-color);
  color: var(--shine-background-text-color);
  font-family: Poppins, sans-serif;
  ${({ $wide = false }) => $wide ? '' : 'width: 350px;'}
  max-width: calc(100% - 60px);
  padding: 16px;
  border: 3px solid rgba(255,255,255,0.22);
  border-radius: 12px;
  @media not (${DeviceQueries.mobile}) {
    ${({ $maxWidth }) => $maxWidth ? `max-width: ${$maxWidth}` : ''};
  }
  position: relative;
  overflow-y: scroll;
`;

export const ModalClose = styled.div`
  float: right;
  height: 0;
  cursor: pointer;
  margin-top: -10px;
  margin-right: -10px;
`;

export const Title = styled.h1`
  font-size: 24px;
  margin: 0 25px 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
`;
